<!--
 * @Descripttion: 
 * @version: 
 * @Author: szj
 * @Date: 2023-03-06 09:05:38
 * @LastEditors: szj
 * @LastEditTime: 2025-07-04 10:22:12
-->
<template>
  <!-- <a-config-provider :locale="locale">
  </a-config-provider> -->
  <ConfigProvider :locale="zhCN">
    <div class="demo-app">
      <router-view />
    </div>
  </ConfigProvider>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";
import { useMyStore } from "./store";
import GMap from "/@/components/GMap.vue";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { ConfigProvider } from "ant-design-vue";
// import dayjs from "dayjs"
// import "dayjs/locale/zh-cn"
// dayjs.locale("zh-cn")
// import moment from 'moment';
// import 'moment/locale/zh-cn';
import "moment/dist/locale/zh-cn";
// moment.locale('zh-cn');

// import dayjs from "dayjs"
// import *  as dayjs from 'dayjs';
// import "dayjs/locale/zh-cn"
// dayjs.locale("zh-cn")

export default defineComponent({
  name: "App",
  components: { GMap, ConfigProvider },

  setup() {
    const store = useMyStore();
    return { zhCN };
  },
});
</script>
<style lang="scss" scoped>
.demo-app {
  width: 100%;
  height: 100%;
  // font-family: 'siyuansongti';

  .map-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>

<style lang="scss">
#demo-app {
  width: 100%;
  height: 100%;
}
</style>
